<template>
  <div class="reporting">
    <a class="d-back-link" href="/calendar">Tilbage til Docendo</a>
    <div class="reporting__header">
      <div class="reporting__header__right">
        <h1>Kompetenceindberetning</h1>
      </div>
    </div>
    <div class="d-tabs">
      <div class="d-tabs__tab" v-for="(tab, prop) in theTabs"
           :class="[
               {'d__tabs__tab--inactive': tab.inactive},
               {'d-tabs__tab--active': getIsTheActiveTab(prop)}
               ]"
           @click="setTheActiveTab(tab, prop)">
        {{ prop }}. {{ tab.title }}
      </div>
    </div>
    <div v-if="isLoadingStilData" style="width: 500px">
      <Loader></Loader>
    </div>
    <div class="reporting-content" v-else>
      <div class="reporting__table">
        <component
          :is="theActiveComponent"
          :standardSubjects="standardSubjects"
          :stilData="stilData"
          :dbStilData="dbStilData"
          :isShowSubjects="isShowSubjects"
          :usersSSNHash="usersSSNHash"
          :klokketimetyper="klokketimetyper"
          @updateStil="updateStil"
          @updateStilReportUser="updateStilReportUser">
        </component>
      </div>
    </div>
  </div>
</template>

<script>
import docendo from '../../../docendo.js'
import Loader from '../../common/Loader'
import ChangeSchoolYear from '../../School/ChangeSchoolYear'
import StilGuides from './../StilGuides'
import KompetenceIndberetningLinjeFag from './KompetenceIndberetningLinjeFag'
import KompetenceIndberetningKlasser from './KompetenceIndberetningKlasser'
import KompetenceIndberetningDaekning from './KompetenceIndberetningDaekning'
import eventbus from '../../../eventbus'
import KompetenceIndberetningIndberet from './KompetenceIndberetningIndberet'

export default {
  components: {
    KompetenceIndberetningIndberet,
    StilGuides,
    ChangeSchoolYear,
    Loader,
    KompetenceIndberetningLinjeFag,
    KompetenceIndberetningKlasser,
    KompetenceIndberetningDaekning
  },
  data () {
    return {
      dbStilData: null,
      stilData: null,
      isLoadingStilData: false,
      theActiveTab: 1,
      theTabs: {
        1: {
          title: 'Undervisningskompetencer',
          component: KompetenceIndberetningLinjeFag
        },
        2: {
          title: 'Klasser',
          component: KompetenceIndberetningKlasser
        },
        3: {
          title: 'Fag',
          component: KompetenceIndberetningKlasser,
          isShowSubjects: true
        },
        4: {
          title: 'Kompetencedækning',
          component: KompetenceIndberetningDaekning
        },
        5: {
          title: 'Resumé og indberet',
          component: KompetenceIndberetningIndberet
        }
      },
      theActiveComponent: KompetenceIndberetningLinjeFag,
      standardSubjects: [
        {subject_code: 110, fagkode: '110', name: 'Dansk'},
        {subject_code: 120, fagkode: '120', name: 'Engelsk'},
        {subject_code: 130, fagkode: '130', name: 'Tysk (tilbudsfag)'},
        {subject_code: 134, fagkode: '134', name: 'Tysk (valgfag)'},
        {subject_code: 140, fagkode: '140', name: 'Fransk (tilbudsfag)'},
        {subject_code: 144, fagkode: '144', name: 'Fransk (valgfag)'},
        {subject_code: 170, fagkode: '170', name: 'Kristendomskundskab'},
        {subject_code: 171, fagkode: '171', name: 'Kristendomskundskab/religion'},
        {subject_code: 181, fagkode: '181', name: 'Historie'},
        {subject_code: 182, fagkode: '182', name: 'Samfundsfag'},
        {subject_code: 210, fagkode: '210', name: 'Idræt'},
        {subject_code: 220, fagkode: '220', name: 'Musik'},
        {subject_code: 230, fagkode: '230', name: 'Billedkunst'},
        {subject_code: 240, fagkode: '240', name: 'Håndarbejde'},
        {subject_code: 245, fagkode: '245', name: 'Håndværk og design'},
        {subject_code: 250, fagkode: '250', name: 'Sløjd'},
        {subject_code: 260, fagkode: '260', name: 'Madkundskab'},
        {subject_code: 310, fagkode: '310', name: 'Matematik'},
        {subject_code: 320, fagkode: '320', name: 'Fysik/kemi'},
        {subject_code: 330, fagkode: '330', name: 'Geografi'},
        {subject_code: 340, fagkode: '340', name: 'Biologi'},
        {subject_code: 350, fagkode: '350', name: 'Natur/teknik'},
        {subject_code: 511, fagkode: '511', name: 'Praktisk/Musisk valgfag: Håndværk/design'},
        {subject_code: 520, fagkode: '520', name: 'Praktisk/Musisk valgfag: Musik'},
        {subject_code: 531, fagkode: '531', name: 'Praktisk/Musisk valgfag: Billedkunst'},
        {subject_code: 540, fagkode: '540', name: 'Praktisk/Musisk valgfag: Madkundskab'},
        {subject_code: 600, fagkode: '600', name: 'Børnehaveklasse'}
      ],
      isShowSubjects: false,
      klokketimetyper: {
        1: 'Almindelig undervisning',
        10: 'Tolærerordning',
        20: 'Undervisningsassistenter og pædagoger',
        30: 'Supplerende undervisning af enkelte elever',
        91: 'Andet',
        92: 'Ej specificeret på nuværende tidspunkt'
      }
    }
  },
  computed: {
    schoolId () {
      return this.$route.params.school_id
    },
    users () {
      return this.$store.getters.usersSortedOnName
    },
    usersSSNHash () {
      const users = this.users.filter(user => this.getUserStilling(user))
      return this.$helpers.hashMap(users, 'ssn')
    },
    userIdsKlasseFagMap () {
      // {cpr: [klasse_id _ fag_id]}
      const fagOnUserMap = {}
      this.stilData.klasser.forEach(klasse => {
        klasse.fag.forEach(fag => {
          fag.laerere.forEach(learer => {
            const vUid = klasse.klasse_id + '_' + fag.fag_id
            const vFag = {
              vUid: vUid,
              user_id: learer.user_id,
              cpr: learer.cpr,
              klassebetegnelse: klasse.klassebetegnelse,
              klasse_id: klasse.klasse_id,
              klasse_type: klasse.klasse_type,
              klasse_klokketimer: fag.klokketimer,
              fag_id: fag.fag_id,
              fag_navn: fag.fag_navn,
              fagkode: fag.fagkode,
              learer_klokketimer: learer.klokketimer,
              klokketimer_type: learer.klokketimer_type
            }
            if (learer.user_id) {
              if (!fagOnUserMap[learer.user_id]) {
                fagOnUserMap[learer.user_id] = [vFag]
              } else {
                fagOnUserMap[learer.user_id].push(vFag)
              }
            }
          })
        })
      })
      return fagOnUserMap
    }
  },
  methods: {
    getUserStilling (user) {
      return user.custom_data && user.custom_data.schools && user.custom_data.schools[this.schoolId] && user.custom_data.schools[this.schoolId]['stilling'] && user.custom_data.schools[this.schoolId]['stilling'] !== 'undtaget'
    },
    getIsTheActiveTab (prop) {
      return this.theActiveTab * 1 === prop * 1
    },
    setTheActiveTab (tab, prop) {
      this.theActiveComponent = tab.component
      this.theActiveTab = prop
      this.isShowSubjects = tab['isShowSubjects']
      if (prop === '5') {
        this.removeTeachersWithoutStilling()
      } else {
        this.readStilCompetencyReport()
      }
    },
    readStilCompetencyReport () {
      this.isLoadingStilData = true
      docendo.showStilCompetencyReport(this.schoolId, success => {
        this.isLoadingStilData = false
        this.stilData = success
        this.dbStilData = success
      }, failure => {
        console.log('failure')
      })
    },
    updateStil (report) {
      docendo.updateStilCompetencyReport(this.schoolId, report, success => {
        eventbus.toast = {text: 'Opdateret', success: true}
        this.stilData = success
        this.dbStilData = success
      }, failure => {
        eventbus.toast = {text: 'Noget gik galt', success: false}
      })
    },
    removeTeachersWithoutStilling () {
      this.isLoadingStilData = true
      let report = JSON.parse(JSON.stringify(this.dbStilData))
      report['laerere'] = this.stilData['laerere'].filter(laerer => laerer.stilling !== 'undtaget')
      // this.updateStil(report)
      docendo.updateStilCompetencyReport(this.schoolId, report, success => {
        this.readStilCompetencyReport()
      })
    },
    updateStilReportUser (user) {
      const userId = user.id
      const SSN = user.ssn
      const userSubjects = this.userIdsKlasseFagMap[userId] || []
      let report = JSON.parse(JSON.stringify(this.dbStilData))

      userSubjects.forEach(itemFag => {
        const klasse = report.klasser.find(klasse => klasse.klasse_id === itemFag.klasse_id)
        if (!klasse) return // Early exit if klasse is not found

        const fag = klasse.fag.find(fag => fag.fag_id === itemFag.fag_id)
        if (!fag) return // Early exit if fag is not found

        const teacher = fag.laerere.find(teacher => teacher.user_id === userId)
        if (teacher) {
          teacher.cpr = SSN // Only update if teacher is found
        }
      })

      this.updateStil(report)
    }
  },
  mounted () {
    this.readStilCompetencyReport()
    this.$store.dispatch('getUsersFromSchoolId', this.schoolId)
    this.$store.dispatch('readSchoolYears', this.schoolId)
  }
}
</script>

<style scoped>
@import "../../../assets/css/variables.css";

.reporting {
  margin: 1rem;
}

.reporting__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1440px;
  min-width: 1100px;
}

.reporting__header__right {
  display: flex;
  align-items: center;
}

.reporting__header h1 {
  margin-right: 1rem;
}

.d-tabs {
  display: flex;
  align-items: stretch;
}

.d-tabs__tab {
  border-radius: 4px 4px 0 0;
  padding: 1rem 2rem;
  margin-bottom: -1px;
  margin-right: 0;
  font-weight: bold;
  cursor: pointer;
}

.d-tabs__tab.d-tabs__tab--active {
  border: 1px solid #d8d8d8;
  border-width: 1px 1px 0 1px;
  color: var(--primary);
}

.d-table thead th.d-table__cell__input__number {
  text-align: center;
}

.d-back-link:hover {
  text-decoration: underline;
}

.d__tabs__tab--inactive {
  cursor: not-allowed !important;
  pointer-events: none !important;
  opacity: 0.6;
}
</style>



// WEBPACK FOOTER //
// KompetenceIndberetning.vue?1e5db58b